/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export const ServiceAccessEnum = {
    AddExpenses: 'addExpenses',
    AddSales: 'addSales',
    Analytics: 'analytics',
    ApproveActivityStatements: 'approveActivityStatements',
    RunCascade: 'runCascade',
    Service: 'service',
    SetAccess: 'setAccess',
    UploadContracts: 'uploadContracts',
    ViewActivityStatements: 'viewActivityStatements',
    ViewAllServiceDisbursements: 'viewAllServiceDisbursements',
    ViewBankFeed: 'viewBankFeed',
    ViewBeneficiaries: 'viewBeneficiaries',
    ViewContracts: 'viewContracts',
    ViewExpenses: 'viewExpenses',
    ViewSales: 'viewSales',
    ViewWaterfall: 'viewWaterfall',
};
